"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cardGridStyle = theme => ({
    borderRadius: '10px',
    padding: '10px',
    backgroundColor: theme === 'light' ? '#FFFFFF' : '#272936'
});
const gridStyle = {
    height: '100%'
};
const footerStyle = {
    textAlign: 'right',
    marginTop: '10px'
};
const cellStyle = {
    textAlign: 'center'
};
exports.default = {
    cellStyle,
    gridStyle,
    footerStyle,
    cardGridStyle,
};
